import { render } from "./AccountBoxMultiple.vue?vue&type=template&id=6d8c5ceb"
import script from "./AccountBoxMultiple.vue?vue&type=script&lang=js"
export * from "./AccountBoxMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__